// Simple text display component
const TextDisplay = ({ value, className = "" }) => {
  const displayValue = value === null || value === undefined || value === '' ? 'null' : value;
  return (
    <p className={`${className} py-1`}>{displayValue}</p>
  );
};

export const PackagesTable = ({ declarationIndex, itemIndex, isSpanish, item, editableData, setEditableData, setIsDirty }) => {

  return (
    <div>
      <div className="form-group flex-1 mt-6 !mb-0 flex justify-between flex-row items-center">
        <label htmlFor="companyName" className="!mb-0 !text-sm !opacity-100 text-xl font-semibold uppercase">{!isSpanish ? "Packages" : "Embalajes"} ({item.embalajes?.length || 0})</label>
        {/* <button
           className="py-1 text-xs flex items-center gap-1"
          onClick={() => {
            const updatedData = [...editableData];
            if (!updatedData[declarationIndex].partidas[itemIndex].embalajes)
              updatedData[declarationIndex].partidas[itemIndex].embalajes = [];
            updatedData[declarationIndex].partidas[itemIndex].embalajes.push({
              // Add default fields as needed
              tipo: "",
              cantidad: "",
              cantidad_restante: "",
              piezas: "",
              es_interno_o_externo: "",
              marcas: [],
            });
            setEditableData(updatedData);
            setIsDirty(true);
          }}
        >
          <Plus className={`size-4`} />
          {isSpanish ? "Agregar Embalaje" : "Add Package"}
        </button> */}
      </div>
      <div className='overflow-auto'>
        <table className="min-w-full border-collapse text-sm">
          <thead>
            <tr>
              <th className="py-2 px-4 pt-2 pl-0"><p className='w-max'>{!isSpanish ? "Type" : "Tipo"}</p></th>
              <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Quantity" : "Cantidad"}</p></th>
              <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Remaining Quantity" : "Cantidad Restante"}</p></th>
              <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Pieces" : "Piezas"}</p></th>
              <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Internal or External" : "Es Interno o Externo"}</p></th>
              <th className="py-2 px-4 pt-2"><p className='w-max'>{!isSpanish ? "Marks" : "Marcas"}</p></th>
            </tr>
          </thead>
          <tbody>
            {item.embalajes?.map((item, embajaIndex) => (
              <tr key={embajaIndex}>
                <td className="py-4 px-4 border-t pl-0">
                  <TextDisplay value={item.tipo} />
                </td>
                <td className="py-4 px-4 border-t">
                  <TextDisplay value={item.cantidad} />
                </td>
                <td className="py-4 px-4 border-t">
                  <TextDisplay value={item?.cantidad_restante} />
                </td>
                <td className="py-4 px-4 border-t">
                  <TextDisplay value={item?.piezas} />
                </td>
                <td className="py-4 px-4 border-t">
                  <TextDisplay value={item.es_interno_o_externo} />
                </td>
                <td className="py-4 px-4 border-t" id={`packages_marcas_${declarationIndex}_${itemIndex}_${embajaIndex}`}>
                  <div className='w-fit flex flex-col gap-1'>
                    {item.marcas?.map((marca, marcaIndex) => (
                      <div key={marcaIndex} className="flex items-center gap-2">
                        <TextDisplay value={marca.marca} />
                      </div>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </div>


  )

}